/**
 * Per-supplier sub-region card per scope §6.1.2. Atlas Day 2 Phase 3.
 *
 * Surface (default): "ISG sources from N suppliers; K active. Lead times
 * range X-Y days; moq constraints encoded per supplier."
 *
 * Surface (N=0 per D3 lock (c) conditional render — eventual-existence framing):
 * "ISG has not yet onboarded any suppliers."
 *
 * Click handler stub for Phase 3 (Phase 6 wires inspect navigation per B.3).
 */

import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Truck } from 'lucide-react';
import type { SupplierSubstrate } from '../../../lib/atlas/perEntitySubstrate';

export interface PerSupplierCardProps {
  substrate: SupplierSubstrate;
}

export default function PerSupplierCard({ substrate }: PerSupplierCardProps): JSX.Element {
  const navigate = useNavigate();
  const { total, active, leadTimeRange } = substrate;
  const isEmpty = total === 0;
  const surfaceLine = isEmpty
    ? 'ISG has not yet onboarded any suppliers.'
    : leadTimeRange
      ? `ISG sources from ${total} ${total === 1 ? 'supplier' : 'suppliers'}; ${active} active. Lead times range ${leadTimeRange.min}-${leadTimeRange.max} days; moq constraints encoded per supplier.`
      : `ISG sources from ${total} ${total === 1 ? 'supplier' : 'suppliers'}; ${active} active. Lead time data not yet recorded.`;
  return (
    <button
      type="button"
      data-sub-region-id="per-supplier"
      onClick={() => navigate('/admin/engine-atlas/inspect/per-supplier')}
      className="w-full text-left border border-border-subtle bg-surface-0 rounded-md p-3 hover:border-accent transition-colors cursor-pointer"
    >
      <div className="flex items-start gap-2">
        <Truck size={16} className="text-ink-secondary flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-ink-bright">Per-supplier</h3>
          <p className="text-xs text-ink-secondary mt-1">{surfaceLine}</p>
        </div>
      </div>
    </button>
  );
}
